// extracted by mini-css-extract-plugin
module.exports = {"auth":"AuthLayout_auth__20ZB4","panel":"AuthLayout_panel__oEwax","forgot":"AuthLayout_forgot__14S_H"};